<template>
  <div>
    <b-modal
      id="modal-input-password"
      v-model="modalInputPassword"
      size="lg"
      hide-footer
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      centered
    >
      <div class="box-pin mb-5">
        <div class="heading text-center">
          <h3 class="font-rubik-medium mb-4">
            Masukkan Password
          </h3>
          <p class="font-rubik-regular">
            Silakan masukkan password akun Anda untuk reset PIN
          </p>
        </div>
        <div class="body-pin">
          <p v-if="isStatus === false" class="font-rubik-regular text-center">
            Maaf, Anda memasukkan Password yang salah
          </p>
          <div class="flex">
            <input v-model="password" :type="isShowPassword ? 'text' : 'password'" name="password" :class="isStatus ? '' : 'wrong-password'">
            <div class="relative pt-4">
              <font-awesome-icon
                size="lg"
                :icon="isShowPassword ? 'eye' : 'eye-slash'"
                class="cursor-pointer mt-1"
                @click="toggleShowPassword"
              />
            </div>
          </div>
          <div class="box-forgot mt-3">
            <p class="font-rubik-regular">
              Lupa Password?
              <nuxt-link to="/auth/forgot-password">
                <span>Pulihkan <font-awesome-icon icon="chevron-circle-right" size="lg" />
                </span>
              </nuxt-link>
            </p>
          </div>
        </div>
      </div>
      <div class="box-submit text-center">
        <nuxt-link to="/console/dashboard">
          <button
            class="pl-6 text-white btn-cancel"
          >
            <font-awesome-icon icon="times-circle" size="lg" /> Batal
          </button>
        </nuxt-link>
        <button
          class="pl-6 text-white"
          :class="password.length < 5 || isDisabled ? 'btn-disabled' : ''"
          :disabled="password.length < 5 || isDisabled"
          @click="submitPassword"
        >
          <loading-state v-if="onShowLoading" color="white" class="loadingPin" />
          <font-awesome-icon v-if="password.length > 4 && !isDisabled" icon="check-circle" size="lg" /> Lanjutkan
        </button>
      </div>
    </b-modal>
    <create-pin v-if="showCreatePIN" />
  </div>
</template>
<script>
export default {
  components: {
    createPin: () => import('@/components/modal-dialog/CreatePin.vue'),
    loadingState: () => import('@/components/LoadingState')
  },
  data () {
    return {
      modalInputPassword: true,
      password: '',
      isStatus: true,
      isDisabled: true,
      showCreatePIN: false,
      onShowLoading: false,
      isShowPassword: false
    }
  },
  watch: {
    password (val) {
      if (val.length === 0) {
        this.isStatus = true
      } else if (val.length > 4) {
        this.isDisabled = false
      }
    }
  },
  methods: {
    toggleShowPassword () {
      this.isShowPassword = !this.isShowPassword
    },
    async submitPassword () {
      this.onShowLoading = true
      this.isDisabled = true
      const formData = new FormData()
      formData.append('PIN', '')
      formData.append('Password', this.password)
      formData.append('PIN_confirmation', '')
      await this.$store.dispatch('user/changePIN', formData)
        .then((res) => {
          if (res) {
            this.modalInputPassword = false
            this.showCreatePIN = true
          }
        })
        .catch((err) => {
          this.onShowLoading = false
          this.isDisabled = false
          if (err.data.Data === 'WRONG_PASSWORD') {
            this.isStatus = false
          }
        })
    }
  }
}
</script>

<style lang="scss">
  #modal-input-password {
    background: #024668d1 !important;
    .modal-body {
      padding: 3rem;
      .heading {
        h3 {
          color: #434343;
          font-size: 24px;
        }
        p {
          color: #434343;
          font-size: 18px;
        }
      }
      .body-pin {
        p {
          color: #E70016;
          font-size: 18px;
        }
        .flex {
          display: flex;
          input {
            border: 0px;
            width: 100%;
            height: 70px;
            font-size: 60px;
            text-align: left;
            padding: 0px 20px;
            margin-right: 20px;
            border-radius: 7px;
            background-color: #f3f2ef;
            &:focus-visible {
              outline: 0px;
            }
            &.wrong-password {
              border: 1px solid #E70016;
            }

            @media (max-width: 1200px) {
              font-size: 50px;
            }
          }
        }
      }
      .box-submit {
        margin-top: 4.5rem;
        button {
          width: 185px;
          height: 40px;
          padding: 0px;
          margin: 0px 15px;
          overflow: hidden;
          position: relative;
          background: #00C300;
          border-radius: 20px;
          border: 1px solid #00C300;
          svg {
            position: absolute;
            left: 10px;
            top: 8px;
          }
          &.btn-disabled {
            background: #bfbfbf;
            border: 1px solid #bfbfbf;
          }
          &.btn-cancel {
            background: #E70016;
            border: 1px solid #E70016;
          }
          .loadingPin {
            top: 0;
            width: 100%;
            height: 100%;
            margin: auto;
            padding-top: 7px;
            position: absolute;
            text-align: center;
            background: #00000036;
          }
        }
      }
    }
    .box-forgot {
      p {
        color: #434343 !important;
        font-weight: 600;
        span {
          color: #E70016;
          cursor: pointer;
          svg {
            font-size: 19px;
          }
        }
        a {
          &:hover {
            text-decoration: none;
          }
        }
      }
    }
  }
</style>
